import InputStorePicker from './input-store-picker-view'

export default InputStorePicker
